import { ControlLabel, DropdownItem, Radio } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import isEqual from 'lodash/isEqual'
import parseBoolean from 'utils/parseBoolean'
import ActionButtons from 'components/Filters/ActionButtons'
import styles from 'components/Filters/FilterPanel/subcomponents/Dropdown/Dropdown.module.scss'

const RadioGroup = ({
  name,
  onApply = () => {},
  showActionButtons = true,
  onSelect = () => {},
  value = undefined,
  options = [],
  defaultValue = undefined,
  optionLabelPrefix = '',
  lock = false,
}) => {
  const { t } = useTranslation()
  const [checked, setChecked] = useState(value)

  useEffect(() => !isEqual(checked, value) && setChecked(value), [value])

  useEffect(() => onSelect(checked), [checked])

  const applyValue = useCallback(() => {
    onApply({ fieldName: name, value: checked })
  }, [checked])

  const dropFilter = useCallback(() => {
    setChecked(defaultValue)
  }, [])

  return (
    <>
      <div className={styles['dropdown__scroll']}>
        {options.map((option) => (
          <DropdownItem
            size={'m'}
            key={name + '-option' + option}
            onChange={(e) => {
              e.stopPropagation()
              !lock && setChecked(parseBoolean(e.target.value))
            }}
          >
            <ControlLabel
              checked={isEqual(checked, option)}
              name={name}
              value={option}
              control={<Radio />}
              label={t(optionLabelPrefix + option)}
            />
          </DropdownItem>
        ))}
      </div>
      <ActionButtons
        dropFilter={dropFilter}
        applyValue={applyValue}
        showActionButtons={showActionButtons}
      />
    </>
  )
}

RadioGroup.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  optionLabelPrefix: PropTypes.string,
  value: PropTypes.any,
  options: PropTypes.array,
  onApply: PropTypes.func,
  onSelect: PropTypes.func,
  showActionButtons: PropTypes.bool,
  defaultValue: PropTypes.any,
  lock: PropTypes.bool,
}

export default RadioGroup
